import { Utils } from "../../../common/views/Utils";
import { ContactInfo } from "../../../home/models/ContactInfo";
import { OrderModel } from "../../../orders/models/OrderModel";
import { OrderUtils } from "../../../orders/views/shared/OrderUtils";
import { BankAccountModel, InvoiceDetailModel } from "../../models/InvoiceModel";
import InvoicePrintContactView from "./InvoicePrintContactView";
import InvoicePrintItemView from "./InvoicePrintItemView";
import InvoicePrintPaymentView from "./InvoicePrintPaymentView";

type InvoicePrintProps = {
    invoice: InvoiceDetailModel;
    bankAccounts: BankAccountModel[];
    contacts: ContactInfo[];
    onOrderDetail?: (order: OrderModel) => void;
}

export default function InvoicePrintView({ invoice, bankAccounts, contacts, onOrderDetail }: InvoicePrintProps) {
    const countryCode = invoice.phone?.countryCode ?? "";
    const phoneNo = invoice.phone?.phoneNo ?? "";

    const width6 = Utils.getColumnWidth(6);

    const header = () => {
        return <div className="p-10 blue-background">
            <div className="ms-Grid-row">
                <div className={width6}>{invoice.id}</div>
                <div className={width6 + " right"}>{Utils.formatShortDate(invoice.date)}</div>
            </div>

            <div className="pt-5">{Utils.formatPhone2(countryCode, phoneNo)}</div>

            {!Utils.isNullOrEmpty(invoice.addressLine) &&
                <div className="pt-5">{invoice.addressLine}</div>}
        </div>;
    }

    const getTotalQty = () => {
        let total = 0;

        for (let i = 0; i < invoice.items.length; i++) {
            total += invoice.items[i].qty;
        }

        return total;
    }

    const getSubTotal = () => {
        let total = 0;

        for (let i = 0; i < invoice.items.length; i++) {
            total += OrderUtils.getAmount(invoice.items[i]) + invoice.items[i].domesticShipping;
        }

        return total;
    }

    const subTotal = getSubTotal();
    const txtRate = invoice.shippingRate.toFixed(1);
    const txtWeight = invoice.chargeWeight.toFixed(1);
    const shippingFee = invoice.shippingRate * invoice.chargeWeight;
    const total = subTotal + shippingFee + invoice.shipping;
    const remainging = total - invoice.paid;

    const summaryRow = (text: string, value: number) => {
        return <div className="ms-Grid-row pv-5">
            <div className={width6 + " left"}>{text}</div>
            <div className={width6 + " right"}>$ {value.toFixed(2)}</div>
        </div>
    }

    const summary = () => {
        return <div className="p-10 blue-background">
            {summaryRow("Total Qty:", getTotalQty())}
            {summaryRow("Sub Total:", subTotal)}

            <div className="ms-Grid-row">
                <div className={width6 + " left"}>
                    Shipping Fee: ($ {txtRate} x {txtWeight} lbs)
                </div>
                <div className={width6 + " right"}>$ {shippingFee}</div>
            </div>

            {summaryRow("Delivery Fee:", invoice.shipping)}
            {summaryRow("Total:", total)}
            {summaryRow("Paid:", invoice.paid)}

            <div className="firmed font-bolder">
                {summaryRow("Remaining:", remainging)}
            </div>
        </div>
    }

    return <div className="ms-Grid ml--10 mr--10 pb-10">
        {header()}

        <div className="ph-10">
            {invoice.items.map((order: OrderModel) => {
                return <InvoicePrintItemView order={order} onOrderDetail={onOrderDetail} />
            })}
        </div>

        {summary()}

        <div className="pt-10">
            <InvoicePrintPaymentView accounts={bankAccounts} />
        </div>

        <div className="pt-10">
            <InvoicePrintContactView contacts={contacts} />
        </div>
    </div>;
}